import { render, staticRenderFns } from "./SaleInfoOverview.vue?vue&type=template&id=5aaa7a81&scoped=true"
import script from "./SaleInfoOverview.vue?vue&type=script&lang=ts"
export * from "./SaleInfoOverview.vue?vue&type=script&lang=ts"
import style0 from "./SaleInfoOverview.vue?vue&type=style&index=0&id=5aaa7a81&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaa7a81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aaa7a81')) {
      api.createRecord('5aaa7a81', component.options)
    } else {
      api.reload('5aaa7a81', component.options)
    }
    module.hot.accept("./SaleInfoOverview.vue?vue&type=template&id=5aaa7a81&scoped=true", function () {
      api.rerender('5aaa7a81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleInfoOverview.vue"
export default component.exports